module.exports = __webpack_public_path__ + "static/media/propic.3f17b4f8.jpeg";